// extracted by mini-css-extract-plugin
export var button = "Cookie-module--button--a65b3";
export var modal = "Cookie-module--modal--47c37";
export var title = "Cookie-module--title--b1562";